import Axios from '../utils/Axios';
export type AreaType = {
  area_name: string;
  area_number: 1;
  room: RoomType[];
};
export type RoomType = {
  device_list: DeviceType[];
  name: string;
  number: number;
};
export type DeviceType = {
  area_name: string;
  area_number: number;
  device_app_state: string;
  device_battery: number;
  device_is_charging: number;
  device_issue: string;
  device_updated_at: string;
  device_volume: number;
  logged_at: string;
  loggedin_at: string;
  loggedout_at: string;
  name: string;
  normal: number;
  number: number;
  app_version: string;
  user_token_id: number;
  device_power: number;
  device_wifi_power: number;
  device_memo: string;
  device_status: string;
  is_connected?: number;
  build_version: string | null;
};
export type DevicePathLogType = {
  user_token_id: number;
  store_id: number;
  parent_store_id: number;
  user_id: number;
  path: string;
  params: any | null;
  params2: any | null;
  action_name: string;
  length: number | null;
  index: number | null;
  sector: any | null;
  fill: any | null;
  created_at: string;
  area_name?: string;
  name?: string;
};
export type DeviceDetailType = {
  device_app_state: string;
  device_battery: number;
  device_is_charging: number;
  device_issue: string;
  device_memo: string;
  device_power: number;
  device_updated_at: string;
  device_volume: number;
  device_wifi_power: number;
};
export type StoreStatusData = {
  date: string;
  hour: number;
  store_name: string;
  store_id: number;
  store_availability_yn: number;
  store_open_yn: number;
  store_login_yn: number;
  pause: number;
  parent_store_sector_name: string;
  // description_business_time: string;
  // description_holiday: string;
  created_at: string;
};

export type StoreStatusModalData = {
  store_name: string;
  store_id: number;
  ceo_phone_number: number;
  phone_number: number;
  address1: string;
  address2: string;
  parent_store_sector_name: string;
  description_business_time: string;
  description_holiday: string;
  logo_url_path: string;
  hotel_list: {
    store_name: string;
    user_id: number;
    ad_started_at: string;
    ad_ended_at: string;
    relay_fee_rates: string;
    payment_fee_rates: string;
  }[];
};
export type DeviceTotalType = {
  abnormal_count: string;
  count: number;
  unregistered_room_count: number;
  normal_count: string;
  store_id: number;
  store_name: string;
  alltime_count: number;
  checkin_count: number;
  checkout_count: number;
  over_inactive_count: number;
};
export type HotelListType = {
  value: string;
  label: string;
  store_id: number;
  user_id: number;
  bcode_list: any;
};

export type MappingHotelType = {
  user_x_store_id: number;
  user_id: number;
  store_id: number;
  store_name: string;
  bcode_list: any;
};

export type HotelStoreType = {
  ab_normal_count: number;
  bcode: string;
  close_count: number;
  hotel_name: string;
  name: string;
  open_count: number;
  store_count: number;
  store_id: number;
  user_id: number;
  value: string;
  label: string;
};

export type AreaListType = {
  value: number;
  label: string;
  store_id: number;
  room?: AreaListType[];
};

export type ChatRoomType = {
  store_name: string;
  area_name: string;
  cs_id: number;
  contact_person: string;
  store_id: number | null;
  order_id: string | null;
  order_seq: any | null;
  is_finished: number;
  latest_chat_time: string;
  latest_chat: string;
  unread_count: number;
};

export type ChatDetailType = {
  sender_type: 'ADMIN';
  read: number;
  created_at: string;
  read_at: string | null;
  chat: string;
  failed?: boolean;
};
export type TouchRateType = {
  search_date: string;
  touch_rate_data: TouchRateDataType[];
};
export type TouchRateDataType = {
  store_id: number;
  store_name: string;
  total_store_device: number;
  real_total_store_device: number;
  total_store_touch: number;
  total_device_touch_sum: number;
  unregistered_room_count: number;
  today_touch_rate: string;
  total_stay_seconds: number;
  adver_store_touch: number;
  adver_stay_seconds: number;
  device: TouchRateDeviceType[];
};
export type TouchRateDeviceType = {
  user_token_id?: number;
  area_name?: string;
  name?: string;
  total_device_touch?: number;
  latest_touch?: string;
  latest_touch_at?: string;
  stay_seconds: number;
};
export type TouchLogDataType = {
  path_log_id: number;
  user_token_id: number;
  store_id: number | null;
  parent_store_id: number;
  user_id: number;
  path: string;
  params: any;
  params2: string;
  action_name: string;
  length: number | null;
  index: number | null;
  fill: unknown | null;
  sector: unknown | null;
  created_at: string;
  area_name: string;
  name: string;
  store_name: string;
};
export type StoreDayStatusLogType = {
  abnormal: string;
  non: string;
  noraml: string;
  store_id: number;
  store_name: string;
  user_id: number;
};
export type CounponListType = {
  can_duplicate: number;
  created_at: string;
  creator: number;
  description: string;
  id: number;
  issue_limit_count: number;
  issue_type: number;
  min_order_price: number;
  name: string;
  price: number;
  status: number;
  updated_at: string;
};

const DetectorController = {
  // knockknock HotelList
  getHotelList: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getHotel';
      const response = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 리스트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getHotelStoreTotal: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getHotelStoreTotal';
      const response = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 전체 호텔 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  storeDayStatusLogs: async (oData: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/storeDayStatusLogs';
      const response = await Axios.post(sUrl, oData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 하루 매장 통계 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getHotelDevice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getDevice';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 장비 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getDeviceTotal: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getDeviceTotal';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 장비 전체 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getHotelDevicePathlog: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/pathlog';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 장비 pathlog 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getHotelAllPathlog: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/hotelPathlog';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 전체 pathlog 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getOrderPathlog: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getOrderPath';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock POS pathlog 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getUserTokenInfo: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/store/getUserTokenInfo';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 기기 getUserTokenInfo 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setUserTokenInfo: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/store/setUserTokenInfo';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 기기 getUserTokenInfo 저장하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getStoreStatus: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getStoreStatus';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getStoreStatus 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getStoreList: async (storeId: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${storeId}/getStore`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getStoreList 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔<->매장 맵핑
  getStoreByName: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/admin/getStoreByName`;
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getStoreByName 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getMappingStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getMappingStore';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getMappingStore 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setMappingStore: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/admin/setMappingStore`;
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[setMappingStore 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 매장 호텔 해지
  releaseStore: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/releaseStore`;
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[releaseStore 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getAreaFloorAndRoomByStoreId: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getAreaFloorAndRoomByStoreId';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getAreaFloorAndRoomByStoreId 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getChatRoomList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/directMessage/getChatRoomList';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 채팅 리스트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getChats: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/directMessage/getChats';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 채팅 내용 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  createChatRoom: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/directMessage/createChatRoom';
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 채팅방 생성하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  writeMessage: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/directMessage/writeMessage';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 채팅 전송 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  finishChat: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/directMessage/finishChat';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 채팅 종료 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getSignInData: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getSignInData';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[마스터 로그인 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 기기 터치율 조회
  getStoreTouchRate: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getStoreTouchRate';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기기 터치율 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getStoreTouchLog: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getStoreTouchLog';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기기 터치 로그 상세조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 테스트주문
  getTemplate: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/coupon/getTemplate';
      const response: any = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[테스트주문 쿠폰 리스트 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  testOrderAndCoupon: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/testOrder/testOrderAndCoupon';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[테스트주문 및 쿠폰발급 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default DetectorController;
